// MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS:
//   ROOT: app/assets/webpack_entry/core_webpack.wjs.jsx
// MAGIC_DESPROCKET_END
//= require ./_namespace
//= require_tree .
// MAGIC_DESPROCKET_START
require('sprocket-compat?this!javascripts/auth/_namespace.coffee')
require('sprocket-compat?this!javascripts/auth/email_signup_controller.coffee')
require('sprocket-compat?this!javascripts/auth/oauth_adapter.coffee')
require('sprocket-compat?this!javascripts/auth/oauth_buttons.coffee')
require('javascripts/auth/templates/oauth_error_JST.wjs.js')
// MAGIC_DESPROCKET_END
